import { createAction } from "@reduxjs/toolkit";

import type { OutageType } from "src/types";
import { createModuleActionCreators } from "src/utils";
import { NAME } from "./constants";

const { createEmptyAction } = createModuleActionCreators(NAME);

export const setNextWeek = createEmptyAction("setNextWeek");
export const setPreviousWeek = createEmptyAction("setPreviousWeek");
export const setThisWeek = createEmptyAction("setThisWeek");
export const setActiveOutageType = createAction<OutageType | null>(`${NAME}/activeOutageType`);
